/* 멤버십 페이지 — 사용 방법 슬라이드 진행바 */

function initMembershipTrack(track) {
  const bar = track.closest('.ms-howto').querySelector('[data-ms-bar]');
  if (!bar || track.dataset.barReady === 'true') return;

  track.dataset.barReady = 'true';

  const count = track.children.length;
  if (count < 2) return;

  let ticking = false;

  function paint() {
    const total = track.scrollWidth;
    if (!total) return;

    /* 칸 수로 세면 마지막까지 밀어도 한 칸이 남는다.
       보이는 오른쪽 끝이 전체의 몇 %인지로 잰다 */
    const seen = track.clientWidth + track.scrollLeft;
    const ratio = Math.min(seen / total, 1);

    bar.style.setProperty('--ms-fill', ratio * 100 + '%');
  }

  track.addEventListener('scroll', () => {
    if (ticking) return;
    ticking = true;

    requestAnimationFrame(() => {
      ticking = false;
      paint();
    });
  }, { passive: true });

  window.addEventListener('resize', paint);

  paint();
}

/* PC 는 스크롤 막대가 없다. 좌우 버튼으로 한 장씩 넘긴다 */
function initMembershipNav(track) {
  const stage = track.parentElement;
  const buttons = stage.querySelectorAll('[data-ms-nav]');

  if (!buttons.length || track.dataset.navReady === 'true') return;
  track.dataset.navReady = 'true';

  function step() {
    const first = track.firstElementChild;
    if (!first) return 0;

    const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    return first.getBoundingClientRect().width + gap;
  }

  function sync() {
    const max = track.scrollWidth - track.clientWidth;

    buttons.forEach((button) => {
      const back = button.dataset.msNav === '-1';
      button.disabled = back ? track.scrollLeft <= 1 : track.scrollLeft >= max - 1;
    });
  }

  buttons.forEach((button) => {
    button.addEventListener('click', () => {
      track.scrollBy({ left: step() * Number(button.dataset.msNav), behavior: 'smooth' });
    });
  });

  track.addEventListener('scroll', sync, { passive: true });
  window.addEventListener('resize', sync);
  sync();
}

function init(scope) {
  (scope || document).querySelectorAll('[data-ms-track]').forEach((track) => {
    initMembershipTrack(track);
    initMembershipNav(track);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => init());
} else {
  init();
}

/* 아코디언을 펼치면 폭이 잡히므로 다시 계산한다 */
document.addEventListener('toggle', () => init(), true);
document.addEventListener('shopify:section:load', (event) => init(event.target));
